import Home 								                    from '@/views/Home'

import BrokerHome                               from '@/views/broker/Home'
import BrokerAccount                            from '@/views/broker/Account'
import BrokerPassword                           from '@/views/broker/Password'
import BrokerMultiFactorAuth                    from '@/views/broker/multi-factor-auth/Home'
import BrokerMailSetting                        from '@/views/broker/MailSetting'
import BrokerSiteAppearance                     from '@/views/broker/SiteAppearance'
import BrokerIntegration                        from '@/views/broker/Integration'
import BrokerReferral                           from '@/views/broker/Referral'
import BrokerTemplate                           from '@/views/broker/template/Home'
import BrokerLeadCapture                        from '@/views/broker/lead-capture/Home'
import BrokerNotifications                      from '@/views/broker/Notifications'
import BrokerClientSources                      from '@/views/broker/client-sources/Home'
import BrokerUnsubscribe                        from '@/views/broker/Unsubscribe'
import BrokerSendBirthdayEmail                  from '@/views/broker/SendBirthdayEmail'
import BrokerSendFixedRateExpiryEmail           from '@/views/broker/SendFixedRateExpiryEmail'

import Bankstatements from "../views/Bankstatements";

import BrokerPayment                            from '@/views/broker/payment/Home'
import BrokerStripe                             from '@/views/broker/payment/stripe/Home'

import BrokerOnboardHome                        from '@/views/broker/onboard/Home'

import BrokerOnboardFirstClient                 from '@/views/broker/onboard/first-client/Home'
import BrokerOnboardFirstClientIntro            from '@/views/broker/onboard/first-client/Intro'
import BrokerOnboardFirstClientOne              from '@/views/broker/onboard/first-client/One'
import BrokerOnboardFirstClientTwo              from '@/views/broker/onboard/first-client/Two'
import BrokerOnboardFirstClientThree            from '@/views/broker/onboard/first-client/Three'
import BrokerOnboardFirstClientDone             from '@/views/broker/onboard/first-client/Done'

import BrokerOnboardPersonalize                 from '@/views/broker/onboard/personalize/Home'
import BrokerOnboardPersonalizeIntro            from '@/views/broker/onboard/personalize/Intro'
import BrokerOnboardPersonalizeOne              from '@/views/broker/onboard/personalize/One'
import BrokerOnboardPersonalizeTwo              from '@/views/broker/onboard/personalize/Two'
import BrokerOnboardPersonalizeThree            from '@/views/broker/onboard/personalize/Three'
import BrokerOnboardPersonalizeFour             from '@/views/broker/onboard/personalize/Four'
import BrokerOnboardPersonalizeDone             from '@/views/broker/onboard/personalize/Done'

// hello
import AuthLogin									              from '@/views/auth/Login'
import AuthRegister								              from '@/views/auth/register/Register'
import AuthLinkSentToClient                     from '@/views/auth/register/LinkSentToClient'
import AuthConfirmRegistration		              from '@/views/auth/register/Confirm'
import AuthRegistrationSuccess   	              from '@/views/auth/register/Success'
import AuthForgotPassword					              from '@/views/auth/forgot-password/ForgotPassword'
import AuthForgotPasswordSent 		              from '@/views/auth/forgot-password/Sent'
import AuthResetPassword 					              from '@/views/auth/reset-password/ResetPassword'
import AuthResetPasswordSuccess		              from '@/views/auth/reset-password/Success'
import AuthUnauthorized                         from '@/views/auth/Unauthorized'
import AuthCheckMFA                             from '@/views/auth/CheckMFA'

// for clients
import ClientOverview                           from '@/views/client/Overview'
import ClientHome                               from '@/views/client/Home'
import ClientActivity                           from '@/views/client/activity/Home'
import ClientList                               from '@/views/client/list/Home'
import ClientLanding                            from '@/views/client/Landing'
import ClientLoggedOut                          from '@/views/client/LoggedOut'
import ClientLandingOld                         from '@/views/client/LandingOld'
import ClientLinkError                          from '@/views/client/LinkError'

import ClientLeadCapture                        from '@/views/client/lead-capture/Home'
import ClientLeadCapturePrimaryReason           from '@/views/client/lead-capture/PrimaryReason'
import ClientLeadCaptureContact                 from '@/views/client/lead-capture/Contact'
import ClientLeadCaptureLoanAmount              from '@/views/client/lead-capture/LoanAmount'
import ClientLeadCaptureFundForDeposit          from '@/views/client/lead-capture/FundForDeposit'
import ClientLeadCaptureCreditHistory           from '@/views/client/lead-capture/CreditHistory'
import ClientLeadCaptureSubmitted               from '@/views/client/lead-capture/Submitted'

// application
import ApplicationHome                          from '@/views/application/Home'
import ApplicationRequirement                   from '@/views/application/requirement/Home'
import ApplicationRiskProfile                   from '@/views/application/risk-profile/Home'
import ApplicationExpense                       from '@/views/application/Expense'
import ApplicationAsset                         from '@/views/application/asset/Home'
import ApplicationLiability                     from '@/views/application/liability/Home'
import ApplicationApplicant                     from '@/views/application/applicant/Home'
import ApplicationApplicantProfile              from '@/views/application/applicant/profile/Home'
import ApplicationApplicantAddress              from '@/views/application/applicant/address/Home'
import ApplicationApplicantEmployment           from '@/views/application/applicant/employment/Home'
import ApplicationDocument                      from '@/views/application/document/Home'
import ApplicationSubmitBroker                  from '@/views/application/submit/BrokerSubmit'
import ApplicationSubmitClient                  from '@/views/application/submit/ClientSubmit'
import ApplicationSubmitted                     from '@/views/application/submit/Submitted'
import ApplicationMercuryConfirm                from '@/views/application/mercury/Confirm'
import ApplicationMercuryProgress               from '@/views/application/mercury/Progress'
import ApplicationMercuryResults                from '@/views/application/mercury/Results'
import ApplicationMercuryTest                   from '@/views/application/mercury/Test'

import MercurySaveApiInfo                       from '@/views/mercury/SaveApiInfo'
import MercuryOpportunityList                   from '@/views/mercury/opportunity/list/Home'
import MercuryOpportunityImport                 from '@/views/mercury/opportunity/import/Home'
import MercuryOpportunityImportConfirm          from '@/views/mercury/opportunity/import/Confirm'
import MercuryOpportunityImportSuccess          from '@/views/mercury/opportunity/import/Success'

// help
import HelpHome                                 from '@/views/help/Home'
import HelpIntro                                from '@/views/help/Intro'
import HelpAccount                              from '@/views/help/Account'
import HelpExpenses                             from '@/views/help/Expenses'
import HelpLeadCapture                          from '@/views/help/LeadCapture'
import HelpTemplates                            from '@/views/help/Templates'
import HelpClients                              from '@/views/help/Clients'
import HelpMercurySetup                         from '@/views/help/MercurySetup'
import HelpMercuryUsage                         from '@/views/help/MercuryUsage'

import PageNotFound		                          from '@/views/PageNotFound'
import LoggedOut                                from '@/views/LoggedOut'

export default [

	// auth related
	{
		path      : '/auth/login',
    name      : 'auth-login',
		component : AuthLogin,
	}, 

  {
		path      : '/auth/register/:referralCode?',
    name      : 'auth-register',
		component : AuthRegister,
	}, 

  {
    path      : '/auth/link-sent-to-client',
    name      : 'auth-link-sent-to-client',
    component : AuthLinkSentToClient,
  }, 

  {
		path      : '/auth/confirm-registration',
    name      : 'auth-confirm-registration',
		component : AuthConfirmRegistration,
	}, {
		path      : '/auth/registration-success/:token',
		component : AuthRegistrationSuccess,
	}, {
		path      : '/auth/forgot-password',
    name      : 'auth-forgot-password',
		component : AuthForgotPassword,
	}, {
		path      : '/auth/forgot-password-sent',
		component : AuthForgotPasswordSent,
	}, {
		path      : '/auth/reset-password/:key',
		component : AuthResetPassword,
	}, {
		path      : '/auth/reset-password-success',
		component : AuthResetPasswordSuccess,
	}, 

  // {
  //   path      : '/auth/bp-v2-pass/check/:key',
  //   name      : 'auth-bp-v2-pass-check',
  //   component : AuthBpV2PassCheck,
  // }, 

  // {
  //   path      : '/auth/bp-v2-pass/form/:key',
  //   name      : 'auth-bp-v2-pass-form',
  //   component : AuthBpV2PassForm,
  // }, 

  // {
  //   path      : '/auth/bp-v2-pass/success',
  //   name      : 'auth-bp-v2-pass-success',
  //   component : AuthBpV2PassSuccess,
  // }, 

  {
    path     : '/auth/unauthorized',
    name     : 'auth-unauthorized',
    component: AuthUnauthorized,
  }, {
    path     : '/auth/check-mfa/:userId',
    name     : 'auth-check-mfa',
    component: AuthCheckMFA,
    props    : true,
  },


  // other pages that are outside of the view/Home
  {
    path     : '/logged-out',
    name     : 'logged-out',
    component: LoggedOut,
  },

  // other pages that are outside of the view/Home
  {
    path     : '/bankstatements',
    name     : 'bankstatements',
    component: Bankstatements,
  },

  // other pages that are outside of the view/Home
  {
    path     : '/client/logged-out',
    name     : 'client-logged-out',
    component: ClientLoggedOut,
  },

  {
    path     : '/client/:clientId/landing/:key',
    name     : 'client-landing',
    component: ClientLanding,
  },

  {
    path     : '/welcome/:key',
    name     : 'client-landing-old',
    component: ClientLandingOld,
  },

  {
    path     : '/client/link-error/:type',
    name     : 'client-link-error',
    component: ClientLinkError,
  },

  {
    path     : '/client/lead-capture/:brokerId',
    name     : 'client-lead-capture',
    component: ClientLeadCapture,
    children : [{
      path     : 'primary-reason/:data?',
      name     : 'client-lead-capture-primary-reason',
      component: ClientLeadCapturePrimaryReason,
    }, {
      path     : 'contact/:data?',
      name     : 'client-lead-capture-contact',
      component: ClientLeadCaptureContact,
    }, {
      path     : 'loan-amount/:data?',
      name     : 'client-lead-capture-loan-amount',
      component: ClientLeadCaptureLoanAmount,
    }, {
      path     : 'fund-for-deposit/:data?',
      name     : 'client-lead-capture-fund-for-deposit',
      component: ClientLeadCaptureFundForDeposit,
    }, {
      path     : 'credit-history/:data?',
      name     : 'client-lead-capture-credit-history',
      component: ClientLeadCaptureCreditHistory,
    }, {
      path     : 'submitted',
      name     : 'client-lead-capture-submitted',
      component: ClientLeadCaptureSubmitted,
    }]
  },

  {
    path     : '/bp-lcf/:id',
    name     : 'client-lead-capture-short',
    component: ClientLeadCapture,
  },

  {
    path     : '/broker/:brokerId/unsubscribe/:key',
    component: BrokerUnsubscribe,
    name     : 'broker-unsubscribe',
  },



  // Onboarding
  {
    path     : '/broker/onboard/:brokerId',
    component: BrokerOnboardHome,
    name     : 'broker-onboard-home',
    meta     : { auth : true },
  },

  {
    path     : '/broker/onboard/:brokerId/first-client',
    name     : 'broker-onboard-first-client',
    component: BrokerOnboardFirstClient,
    meta     : { auth : true},
    children : [{
      path     : 'intro',
      name     : 'broker-onboard-first-client-intro',
      component: BrokerOnboardFirstClientIntro,
      meta     : { auth : true},
    }, {
      path     : 'one/:data?',
      name     : 'broker-onboard-first-client-one',
      component: BrokerOnboardFirstClientOne,
      meta     : { auth : true},
    }, {
      path     : 'two/:data?',
      name     : 'broker-onboard-first-client-two',
      component: BrokerOnboardFirstClientTwo,
      meta     : { auth : true},
    }, {
      path     : 'three/:data?',
      name     : 'broker-onboard-first-client-three',
      component: BrokerOnboardFirstClientThree,
      meta     : { auth : true},
    }, {
      path     : 'done',
      name     : 'broker-onboard-first-client-done',
      component: BrokerOnboardFirstClientDone,
      meta     : { auth : true},
    }]
  },

  {
    path     : '/broker/onboard/:brokerId/personalize',
    name     : 'broker-onboard-personalize',
    component: BrokerOnboardPersonalize,
    meta     : { auth : true},
    children : [{
      path     : 'intro',
      name     : 'broker-onboard-personalize-intro',
      component: BrokerOnboardPersonalizeIntro,
      meta     : { auth : true},
    }, {
      path     : 'one',
      name     : 'broker-onboard-personalize-one',
      component: BrokerOnboardPersonalizeOne,
      meta     : { auth : true},
    }, {
      path     : 'two',
      name     : 'broker-onboard-personalize-two',
      component: BrokerOnboardPersonalizeTwo,
      meta     : { auth : true},
    }, {
      path     : 'three',
      name     : 'broker-onboard-personalize-three',
      component: BrokerOnboardPersonalizeThree,
      meta     : { auth : true},
    }, {
      path     : 'four',
      name     : 'broker-onboard-personalize-four',
      component: BrokerOnboardPersonalizeFour,
      meta     : { auth : true},
    }, {
      path     : 'done',
      name     : 'broker-onboard-personalize-done',
      component: BrokerOnboardPersonalizeDone,
      meta     : { auth : true},
    }]
  },



  // just for now, move it here, should move back to home
  {
    path     : '/client/:clientId/overview',
    name     : 'client-overview',
    component: ClientOverview,
    meta     : { auth : true }
  },

  {
    path     : '/', // key is for clients landing on brokerpad from the email
    name     : 'home',
    component: Home,
    meta     : { auth : true },
    children : [

      // application
      {
        path     : 'application/:clientId',
        name     : 'application-home',
        component: ApplicationHome,
        meta     : { auth : true},
        children : [{
          path     : 'applicant/:applicantId',
          name     : 'application-applicant',
          component: ApplicationApplicant,
          meta     : { auth : true},

          children : [{
            path     : 'profile',
            name     : 'application-applicant-profile',
            component: ApplicationApplicantProfile,
            meta     : { auth : true},
          }, {
            path     : 'address',
            name     : 'application-applicant-address',
            component: ApplicationApplicantAddress,
            meta     : { auth : true},
          }, {
            path     : 'employment',
            name     : 'application-applicant-employment',
            component: ApplicationApplicantEmployment,
            meta     : { auth : true},
          }]
        }, {
          path     : 'requirement',
          name     : 'application-requirement',
          component: ApplicationRequirement,
          meta     : { auth : true }
        }, {
          path     : 'risk-profile',
          name     : 'application-risk-profile',
          component: ApplicationRiskProfile,
          meta     : { auth : true }
        }, {
          path     : 'expense',
          name     : 'application-expense',
          component: ApplicationExpense,
          meta     : { auth : true }
        }, {
          path     : 'liability',
          name     : 'application-liability',
          component: ApplicationLiability,
          meta     : { auth : true }
        }, {
          path     : 'submit/broker',
          name     : 'application-submit-broker',
          component: ApplicationSubmitBroker,
          meta     : { auth : true }
        }, {
          path     : 'submit/client',
          name     : 'application-submit-client',
          component: ApplicationSubmitClient,
          meta     : { auth : true }
        }, {
          path     : 'submitted',
          name     : 'application-submitted',
          component: ApplicationSubmitted,
          meta     : { auth : true }
        }, {
          path     : 'asset',
          name     : 'application-asset',
          component: ApplicationAsset,
          meta     : { auth : true }
        },

        {
          path     : 'mercury-confirm',
          name     : 'application-mercury-confirm',
          component: ApplicationMercuryConfirm,
          meta     : { auth : true }
        },

        {
          path     : 'mercury-results',
          name     : 'application-mercury-results',
          component: ApplicationMercuryResults,
          meta     : { auth : true }
        },

        {
          path     : 'document/:applicantId',
          name     : 'application-document',
          component: ApplicationDocument,
          meta     : { auth : true }
        }]
      },

      {
        path     : 'client/list',
        name     : 'client-list',
        component: ClientList,
        meta     : { auth : true },
      },

      {
        path     : 'client/list-search/:query/:clientType/:status/:access/:primaryReason/:firstHomeBuyer/:clientSource/:orderBy/:orderType/:limit/:offset',
        component: ClientList,
        name     : 'client-list-search',
        meta     : { auth : true },
      },

      {
        path     : 'client/:clientId/activity',
        name     : 'client-activity',
        component: ClientActivity,
        meta     : { auth : true },
      },

      {
        path     : 'client/activity-search/:activityType/:orderBy/:orderType/:limit/:offset',
        name     : 'client-activity-search',
        component: ClientActivity,
        meta     : { auth : true },
      },



      {
        path     : 'client/:clientId/home',
        name     : 'client-home',
        component: ClientHome,
        meta     : { auth : true }
      },

      {
        path     : 'broker/home/:showConfirmRegistration?',
        name     : 'broker-home',
        component: BrokerHome,
        meta     : { auth : true }
      },

      {
        path     : 'broker/:brokerId/account',
        component: BrokerAccount,
        name     : 'broker-account',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/password',
        component: BrokerPassword,
        name     : 'broker-password',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/multi-factor-auth',
        component: BrokerMultiFactorAuth,
        name     : 'broker-multi-factor-auth',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/site-appearance',
        component: BrokerSiteAppearance,
        name     : 'broker-site-appearance',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/integration',
        component: BrokerIntegration,
        name     : 'broker-integration',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/mail-setting',
        component: BrokerMailSetting,
        name     : 'broker-mail-setting',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/payment',
        component: BrokerPayment,
        name     : 'broker-payment',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/stripe',
        component: BrokerStripe,
        name     : 'broker-stripe',
        meta     : { auth : true },
      },

      {
        path     : 'broker/referral/:brokerId',
        component: BrokerReferral,
        name     : 'broker-referral',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/template',
        component: BrokerTemplate,
        name     : 'broker-template',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/lead-capture',
        component: BrokerLeadCapture,
        name     : 'broker-lead-capture',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/notifications',
        component: BrokerNotifications,
        name     : 'broker-notifications',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/client-sources',
        component: BrokerClientSources,
        name     : 'broker-client-sources',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/send-birthday-email/:personId',
        component: BrokerSendBirthdayEmail,
        name     : 'broker-send-birthday-email',
        meta     : { auth : true },
      },

      {
        path     : 'broker/:brokerId/send-fixed-rate-expiry-email/:personId/:liabilityId',
        component: BrokerSendFixedRateExpiryEmail,
        name     : 'broker-send-fixed-rate-expiry-email',
        meta     : { auth : true },
      },

      

      {
        path     : 'mercury/save-api-info',
        component: MercurySaveApiInfo,
        name     : 'mercury-save-api-info',
        meta     : { auth : true },
      },

      {
        path     : 'mercury/opportunity/list',
        component: MercuryOpportunityList,
        name     : 'mercury-opportunity-list',
        meta     : { auth : true },
      },

      {
        path     : 'mercury/opportunity/import',
        component: MercuryOpportunityImport,
        name     : 'mercury-opportunity-import',
        meta     : { auth : true },
      },

      {
        path     : 'mercury/opportunity/import-confirm/:opportunityId',
        component: MercuryOpportunityImportConfirm,
        name     : 'mercury-opportunity-import-confirm',
        meta     : { auth : true },
      },

      {
        path     : 'mercury/opportunity/import-success/:clientId/:applicantId',
        component: MercuryOpportunityImportSuccess,
        name     : 'mercury-opportunity-import-success',
        meta     : { auth : true },
      },

















      {
        path     : 'help/home',
        name     : 'help-home',
        component: HelpHome
      },

      {
        path     : 'help/intro',
        name     : 'help-intro',
        component: HelpIntro
      },

      {
        path     : 'help/account',
        name     : 'help-account',
        component: HelpAccount
      },

      {
        path     : 'help/lead-capture',
        name     : 'help-lead-capture',
        component: HelpLeadCapture
      },

      {
        path     : 'help/templates',
        name     : 'help-templates',
        component: HelpTemplates
      },

      {
        path     : 'help/clients',
        name     : 'help-clients',
        component: HelpClients
      },

      {
        path     : 'help/mercury-setup',
        name     : 'help-mercury-setup',
        component: HelpMercurySetup
      },

      {
        path     : 'help/mercury-usage',
        name     : 'help-mercury-usage',
        component: HelpMercuryUsage
      },

      {
        path     : 'help/expenses',
        name     : 'help-expenses',
        component: HelpExpenses
      },
    ]
  },
]
